import { DEFAULT_FONT } from "src/constants";
import WebFont from "webfontloader";

export function loadFontFamily(context: any, font: string = DEFAULT_FONT) {
    switch (font) {
        case "Cadillac Sans Light":
            WebFont.load({
                custom: {
                    families: ["Cadillac Sans"],
                    urls: [`${process.env.PUBLIC_URL}/fonts/cadillac/cadillac.css`],
                },
                context: context?.frameElement?.contentWindow,
            });

            return "Cadillac Sans";

        case "Lexus":
            WebFont.load({
                custom: {
                    families: ["Nobel:n4,n5,n7"],
                    urls: [`${process.env.PUBLIC_URL}/fonts/lexus/lexus.css`],
                },
                context: context?.frameElement?.contentWindow,
            });

            return "Nobel";

        case "Genesis Sans":
            WebFont.load({
                custom: {
                    families: ["Genesis Sans:400,500,700"],
                    urls: [`${process.env.PUBLIC_URL}/fonts/genesis/genesis.css`],
                },
                context: context?.frameElement?.contentWindow,
            });

            return "Genesis Sans";

        case "Hyundai Sans":
            WebFont.load({
                custom: {
                    families: ["Hyundai Sans:400,500,700"],
                    urls: [`${process.env.PUBLIC_URL}/fonts/hyundai/hyundai.css`],
                },
                context: context?.frameElement?.contentWindow,
            });

            return "Hyundai Sans";

        default:
            WebFont.load({
                google: {
                    families: ["Roboto:300,400,500,700", "Roboto-Bold"],
                },
                context: context?.frameElement?.contentWindow,
            });

            return DEFAULT_FONT;
    }
}
